import { BadgeVerification } from "../../../global/badgeVerification/BadgeVerification";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";

export const ListingVerificationBadge = () => {
  const listingData = useSelector(
    (state: RootState) => state.trainingPlan.listingData,
  );

  return (
    <BadgeVerification
      isFromSpecialist={true}
      type={listingData.user.verificationBadge}
      className="absolute bottom-0 right-0 z-20"
    />
  );
};
